
import styled from 'styled-components';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import UsecaseData from '../components/Usecase/UsecaseData';
import UsecaseIntro from '../components/Usecase/UsecaseIntro';
import UsecaseBanner from '../components/Usecase/UsecaseBanner';
import AppGrowMostBenefits from '../components/AppGrow/AppGrowMostBenefits';
import GrovsDeliver from '../components/Marketing/GrovsDeliver';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { Helmet } from 'react-helmet-async';



const UsecasePage = () => {
    return (
        <>
            <Helmet>
                <title>Smart App Growth Solutions | Track, Engage & Optimize with Grovs</title>
                <meta
                    name="description"
                    content="Grovs offers smart app growth tools for marketers and product teams: precise attribution, seamless deep linking, cross-platform messaging, referral tracking, and real-time analytics."
                />
                <meta
                    name="keywords"
                    content="app growth solutions, deep linking, user engagement, campaign tracking, referral marketing, mobile app growth, user retention, personalized messaging"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Smart App Growth Solutions | Track, Engage & Optimize with Grovs"
                />
                <meta
                    property="og:description"
                    content="Boost app installs, engagement, and retention with Grovs' seamless user journeys, powerful attribution, automated messaging, and clear insights."
                />
                <meta property="og:url" content="https://www.grovs.io/usecase" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/app-growth-banner.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Smart App Growth Solutions | Track, Engage & Optimize with Grovs"
                />
                <meta
                    name="twitter:description"
                    content="Drive installs, increase retention, and optimize ROI with Grovs’ app growth platform featuring deep linking, referral tracking, and cross-platform messaging."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/app-growth-banner.jpg"
                />
            </Helmet>

            <Container>
                <UsecaseIntro />
                <UsecaseData />
                <UsecaseBanner />
                <AppGrowMostBenefits />
                <GrovsDeliver />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.measureBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Ready to Solve Your App Growth Challenges?"}
                    subtitle={"Grovs helps your team clearly track performance, engage users effectively, and confidently optimize marketing strategies."}
                />
                <TrackingComponent />
            </Container>
        </>
    )
}

export default UsecasePage

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;